import Service from '@ember/service';
import * as Sentry from '@sentry/ember';
import { CaptureContext } from '@sentry/types';

import { ApiError } from 'cio/services/api';

export default class RavenService extends Service {
  captureException(err: Error | ApiError, captureContext?: CaptureContext) {
    Sentry.captureException(err, captureContext);
  }

  captureMessage(msg: string) {
    Sentry.captureMessage(msg);
  }

  setUser(user: { id: string; email: string }) {
    Sentry.configureScope((scope) => {
      scope.setUser(user);
    });
  }

  setFullstorySessionUrl() {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    window._fs_ready = function () {
      if (window?.FS?.getCurrentSessionURL) {
        Sentry.configureScope((scope) => {
          // The first argument to getCurrentSessionURL (true) ensures that we're getting the exact moment in time.
          scope.setExtra('fs_session_url', window.FS.getCurrentSessionURL(true));
        });
      }
    };
  }

  withScope(cb: (scope: Sentry.Scope) => unknown) {
    Sentry.withScope(cb);
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    raven: RavenService;
  }
}
